import { Location as HistLocation } from 'history';
import history from 'providers/history';
import { parse, stringify } from 'query-string';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import Router from 'react-router';

import BreadcrumbTrail from 'components/global/application/BreadcrumbTrail';
import VintageGuitarsListingItem from 'components/pages/vintageGuitars/VintageGuitarsListingItem';

import ResultsFooter from 'components/global/application/results_footer/ResultsFooter';
import { VintageGuitarArticlesApi } from 'providers/api'; // build out on back end
import Log from 'providers/log';
import { GetVintageGuitarArticleOptions, GetVintageGuitarArticleOptionsKeys, VintageGuitarArticle, VintageGuitarArticleResponseData } from 'types/drupal/VintageGuitarArticleNode';

import './VintageGuitarsListing.sass';

import { Helmet } from 'react-helmet';

interface Props {
    match: Router.match<{}>;
    location: Location;
}

interface State {
    articlesLoaded: boolean;
    articlesResponse: VintageGuitarArticleResponseData;
}

class VintageGuitarsListing extends React.Component<Props, State> {
    private unregisterHistoryListener: () => void;

    constructor(props: Props) {
        super(props);

        this.state = { articlesResponse: null, articlesLoaded: false };

        this.updateQueryString = this.updateQueryString.bind(this);
        this.updateData = this.updateData.bind(this);
    }

    public componentDidMount() {
        this.updateData(this.props.location);
        this.unregisterHistoryListener = history.listen(location => this.updateData(location));
    }

    public componentWillUnmount() {
        this.unregisterHistoryListener();
    }

    public updateData(location: Location | HistLocation) {
        if (location.pathname !== '/vintage-guitars') return;

        if (location.search.length < 0) {
            VintageGuitarArticlesApi.getVintageGuitarArticles().then((data: VintageGuitarArticleResponseData) => {
                this.setState({
                    articlesLoaded: true,
                    articlesResponse: data
                });
            }).catch(reason => Log.error(reason));
        } else {
            let optionsPresentAndValid = false;
            const queryObj = parse(location.search);
            const queryKeys = Object.keys(queryObj);

            const passable_options: Partial<GetVintageGuitarArticleOptions> = {};    // validate query keys discarding invalid keyValuePairs
            queryKeys.forEach((k: string) => {
                if (GetVintageGuitarArticleOptionsKeys.indexOf(k) !== -1) {
                    const val = queryObj[k];
                    passable_options[k] = val; // === null ? true : val;
                    optionsPresentAndValid = true;
                }
            });

            if (optionsPresentAndValid) {
                VintageGuitarArticlesApi.getVintageGuitarArticles(passable_options).then((data: VintageGuitarArticleResponseData) => {
                    this.setState(
                        {
                            articlesLoaded: true,
                            articlesResponse: data
                        },
                        () => {
                            if (
                                passable_options.hasOwnProperty('page')
                                && passable_options.page > this.state.articlesResponse.last_page
                            ) this.updateQueryString('page', this.state.articlesResponse.last_page.toString());
                        });
                }).catch(reason => Log.error(reason));

            } else {
                VintageGuitarArticlesApi.getVintageGuitarArticles().then((data: VintageGuitarArticleResponseData) => {
                    this.setState({
                        articlesLoaded: true,
                        articlesResponse: data
                    });
                }).catch(reason => Log.error(reason));
            }
        }
    }

    public updateQueryString(key: string, value?: string) {
        const { location, match } = this.props;
        const queryUpdate = parse(location.search);
        queryUpdate[key] = value;   // set to undefined to remove during stringify
        const newQueryString = stringify(queryUpdate);
        history.push(`${match.url}${newQueryString.length > 0 ? `?${newQueryString}` : ''}`);
    }

    public breadcrumbTrail = () => {
        const breadCrumbTrail =  [
            {
                label: 'Home',
                route: '/'
            },
            {
                label: 'Vintage Guitar Magazine Articles',
                route: '/vintage-guitars'
            },
        ];
        return breadCrumbTrail;
    }

    public render() {
        const { articlesResponse, articlesLoaded } = this.state;
        if (!articlesLoaded) return (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />);
        const { data: articles } = articlesResponse;
        return (
            <div>
                <Helmet>
                    <meta name="title" content="Vintage Guitar Magazine Articles by Gruhn Guitar Staff | Gruhn Guitars, Nashville, TN" />
                    <meta name="description" content="Read vintage guitars magazine articles written by Gruhn Guitars staff members. Topics include vintage guitars, pre-war Martins, vintage Gibsons, and more." />
                    <title>Vintage Guitar Magazine Articles by Gruhn Guitar Staff | Gruhn Guitars, Nashville, TN</title>
                </Helmet>
                <div className="Results-breadcrumb offset-md-1 mt-3"><BreadcrumbTrail pathNodes={this.breadcrumbTrail()} /></div>
                <div className="VintageGuitarsListing-container row">
                    <div className="offset-md-1 col-md-10 VintageGuitarListing-col">
                        {articles.map((article: VintageGuitarArticle) => {
                            return <VintageGuitarsListingItem
                                key={article.nid}
                                className="VintageGuitars-item"
                                title={article.title}
                                descriptionHml={article.body.value}
                                // img={(article.hasOwnProperty('field_image') && article.field_image !== null) ? article.field_image.file.url : null}
                                url={'/' + article.alias}
                            />;
                        })}
                        <ResultsFooter
                            currentPage={articlesResponse.current_page}
                            numPages={articlesResponse.last_page}
                            viewNumber={articlesResponse.per_page}
                            numResults={articlesResponse.total}
                            updateQueryString={this.updateQueryString}
                        />
                    </div>
                </div>
            </div>
        );
    }

}

export default VintageGuitarsListing;



// WEBPACK FOOTER //
// ./src/components/pages/vintageGuitars/VintageGuitarsListing.tsx